import { FieldOwnerType } from 'generated/graphql';
import { FC } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { ModalTypes } from '../../../../../enums/modalTypes';
import { openModal } from '../../../../../graphql/modals';
import { TFieldGQL } from '../../../../../interfaces/forms/formGQL';
import useCandidateInfoFieldsListItemStyle from './CandidateInfoFieldsListItemStyle';

interface ICandidateInfoFieldsListItem {
  candidateInfoField: TFieldGQL;
}

const CandidateInfoFieldsListItem: FC<ICandidateInfoFieldsListItem> = ({
  candidateInfoField,
}) => {
  const classes = useCandidateInfoFieldsListItemStyle();

  const handleOpenCreateCandidateInfoFieldModal = () => {
    openModal(ModalTypes.CANDIDATE_INFO_FIELD_MODAL, {
      candidateInfoFieldId: candidateInfoField.id,
    });
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      item
    >
      <Grid xs={3} className={classes.gridItemWrapper}>
        <Typography>{candidateInfoField.name}</Typography>
      </Grid>
      <Grid xs={3} className={classes.gridItemWrapper}>
        <Typography>
          {candidateInfoField.fieldOwnerType ===
          FieldOwnerType.CompanyFieldOwner
            ? candidateInfoField.fieldOwnerName
            : ''}
        </Typography>
      </Grid>
      <Grid xs={3} className={classes.gridItemWrapper}>
        <Typography>{candidateInfoField.formManagerType}</Typography>
      </Grid>
      <Grid xs={2} className={classes.gridItemWrapper}>
        <Button
          onClick={handleOpenCreateCandidateInfoFieldModal}
          className={classes.button}
          variant="contained"
          color="primary"
        >
          Edit
        </Button>
      </Grid>
    </Grid>
  );
};

export default CandidateInfoFieldsListItem;
